import { useState, useEffect } from "react";
import { Alert, TextField, Button, Checkbox, FormControlLabel, Container, Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // API çağrısı için axios kullanıyoruz

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "", rememberMe: false });
  const [error, setError] = useState(""); // Hata mesajı için state
  const navigate = useNavigate(); // Sayfa yönlendirme için


  useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    const savedRememberMe = localStorage.getItem("savedRememberMe");

    if (savedRememberMe === "true" && savedEmail) {
      setCredentials((prev) => ({
        ...prev,
        email: savedEmail,
        rememberMe: true,
      }));
    }
  }, [])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Backend'e API isteği atıyoruz
      const res = await axios.post("/api/auth/admin-login", {
        email: credentials.email, // Kullanıcı adı yerine email kullanılıyor
        password: credentials.password
      });
      // Başarılı giriş -> Token kaydet & yönlendir
      if (credentials.rememberMe) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("savedEmail", credentials.email);
        localStorage.setItem("savedRememberMe", "true");
      } else {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("role", res.data.role);
        localStorage.removeItem("savedEmail");
        localStorage.removeItem("savedRememberMe");
      }
      navigate("/dashboard"); // Admin dashboard'a yönlendir

    } catch (err) {
      setError(err.response?.data?.message || "Giriş başarısız!");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh"
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: "100%", textAlign: "center" }}>
          <Typography variant="h5" gutterBottom>
            Admin Panel
          </Typography>
          {/* LOGO EKLENDİ */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img src={`${process.env.PUBLIC_URL}/bilogo.png`}s alt="Admin Logo" width={150} height={150} />
          </Box>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="E-posta"
              variant="outlined"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Şifre"
              type="password"
              variant="outlined"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              margin="normal"
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <FormControlLabel
                control={<Checkbox name="rememberMe" checked={credentials.rememberMe} onChange={handleChange} />}
                label="Beni Hatırla"
              />
            </Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2, fontWeight: "bold", fontSize: "1rem", padding: "10px" }}>
              Giriş Yap
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AdminLogin;
